import React, { useRef } from 'react';
import { audioEngine } from '../features/audio/audioEngine';
import { useAudio } from '../hooks/useAudio';

export default function SongList() {
    const { trackName } = useAudio();
    const fileInputRef = useRef(null);

    const handleFileSelect = async (e) => {
        const file = e.target.files[0];
        if (file) {
            await audioEngine.loadTrack(file, file.name);
            audioEngine.play();
        }
    };

    return (
        <div className="h-full flex flex-col font-mono text-gray-300">
            {/* Header */}
            <div className="p-4 border-b border-white/5 bg-[#1a1a1a] flex justify-between items-center shadow-lg">
                <span className="text-xs font-bold tracking-widest text-cyan-600">LIBRARY</span>
                <button
                    onClick={() => fileInputRef.current.click()}
                    className="px-3 py-1 bg-[#222] text-xs font-bold text-gray-300 border border-white/10 rounded hover:bg-cyan-900/30 hover:text-cyan-400 hover:border-cyan-500/50 transition-all shadow-[0_2px_4px_black]"
                >
                    + IMPORT
                </button>
                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileSelect}
                    accept="audio/*"
                    className="hidden"
                />
            </div>

            {/* Current Track Display */}
            <div className="p-6 bg-gradient-to-br from-[#151515] to-[#0a0a0a] m-4 rounded border border-white/5 shadow-inner flex flex-col justify-center min-h-[120px]">
                <span className="text-[10px] text-gray-500 uppercase tracking-wider mb-2">Now Loaded</span>
                <marquee behavior="scroll" direction="left" className="text-xl font-light text-cyan-100 drop-shadow-[0_0_5px_rgba(34,211,238,0.3)] truncate">
                    {trackName}
                </marquee>
                <div className="mt-4 flex gap-2">
                    <span className="px-2 py-0.5 text-[9px] bg-black border border-white/10 rounded text-gray-500">USER FILE</span>
                    <span className="px-2 py-0.5 text-[9px] bg-black border border-white/10 rounded text-gray-500">44.1kHz</span>
                </div>
            </div>

            <div className="flex-1 overflow-y-auto px-4 pb-4">
                {/* Placeholder for list */}
                <div className="text-[10px] text-gray-600 text-center mt-8">
                    Import an audio file to begin session.
                </div>
            </div>
        </div>
    );
}
